<template>
    <el-dialog title="选择用户" top="30px" :visible.sync="visible" width="1200px" :close-on-click-modal="false">
        <el-row type="flex" style="margin-top: -20px" justify="space-between">
            <div></div>
            <el-input
                style="width: 300px"
                v-model="query.search_keyword"
                placeholder="输入ID、用户名、手机号进行检索"
                clearable
                suffix-icon="el-icon-search"
                @keyup.enter.native="handleSearch"
            />
        </el-row>
        <ListPage
            ref="listPage"
            :search="false"
            :total="total"
            v-loading="loading"
            :data="tableData"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            @search="handleSearch"
            @reset="resetQuery"
            @selection-change="handleSelectionChange"
        >
            <template slot="columns">
                <el-table-column type="selection" width="50" align="center"></el-table-column>
                <el-table-column label="ID" align="center" prop="uuid" show-overflow-tooltip />
                <el-table-column label="用户名" align="center" prop="nick_name" />
                <el-table-column label="手机" align="center" prop="mobile">
                    <template slot-scope="{ row }">
                        {{ row.mobile || "/" }}
                    </template>
                </el-table-column>
                <el-table-column label="邮箱" align="center" prop="email">
                    <template slot-scope="{ row }">
                        {{ row.email || "/" }}
                    </template>
                </el-table-column>
                <el-table-column label="性别" align="center" prop="sex" width="80">
                    <template slot-scope="{ row }">
                        {{ { 1: "男", 2: "女" }[row.sex] }}
                    </template>
                </el-table-column>
                <el-table-column label="年龄" align="center" prop="age" width="80" />
                <el-table-column label="职业" align="center" prop="job" />
                <el-table-column label="注册时间" align="center" prop="create_time" width="160" />
            </template>
        </ListPage>
        <span slot="footer" class="dialog-footer">
            <el-button @click="visible = false">取 消</el-button>
            <el-button type="primary" @click="handleConfirm">确 定</el-button>
        </span>
    </el-dialog>
</template>

<script>
import { list } from "@/api/member/list";
import listMixin from "@/mixins/list";
export default {
    data() {
        return {
            query: {
                search_keyword: "",
                search_user_role: "1",
            },
            visible: false,
            loading: false,
            options: [],
            ids: [],
            ids_d: [],
            picks: [],
            names: [],
        };
    },
    mixins: [listMixin],
    methods: {
        open() {
            this.visible = true;
            this.search();
        },
        close() {
            this.visible = false;
        },
        search() {
            this.loading = true;
            const params = {
                ...this.query,
            };
            list(params).then(({ code, result, msg }) => {
                if (code === 200) {
                    this.tableData = result.data;
                    this.total = result.total;
                    this.setChecks();
                } else {
                    this.$message.error(msg);
                }
                this.loading = false;
            });
        },
        handleSelectionChange(val) {
            this.ids = val.map((x) => x.uuid);
            this.names = val;
            this.ids_d = this.tableData.filter((x) => this.ids.indexOf(x.uuid) === -1).map((x) => x.uuid);
            this.merge();
        },
        merge() {
            this.ids.forEach((x) => {
                if (!this.picks.find((n) => n.uuid == x)) {
                    this.picks.push({
                        uuid: x,
                        name: this.names.find((n) => n.uuid == x).nick_name,
                    });
                }
            });
            this.ids_d.forEach((x) => {
                if (this.picks.find((n) => n.uuid == x)) {
                    this.picks = this.picks.filter((y) => y.uuid !== x);
                }
            });
        },
        setChecks() {
            this.tableData.map((x) => {
                if (this.picks.find((n) => n.uuid == x.uuid)) {
                    this.$nextTick(() => {
                        this.$refs.listPage.getTableRef().toggleRowSelection(x, true);
                    });
                } else {
                    this.$nextTick(() => {
                        this.$refs.listPage.getTableRef().toggleRowSelection(x, false);
                    });
                }
            });
        },
        handleConfirm() {
            if (this.picks.length === 0) {
                this.$message.warning("请选择用户");
                return;
            }
            this.$emit(
                "pick",
                this.picks.map((x) => x.uuid)
            );
        },
    },
};
</script>

<style></style>
